import React, { useState } from 'react';
import InputField from '../../component/form/FormInput';
import { toast } from 'react-toastify';
import { addNewVendor } from '../../services/vendor';
import Button from '../../component/ui/Button';
import './AddVendorModal.scss';

const AddVendorModal = ({ onClose, handleFormData, vendorList, setVendorList }) => {
	const [addVendorForm, setAddVendorForm] = useState({
		vendor_name: '',
		vendor_display_name: '',
		drug_license_number: '',
		email: '',
		phone_landline: '',
		phone_mobile: '',
	});

	const [vendorError, setVendorError] = useState({});

	const checkValidation = () => {
		const error = { ...vendorError };
		if (
			!addVendorForm.vendor_name ||
			addVendorForm.vendor_name === '' ||
			addVendorForm.vendor_name === null
		) {
			error.vendor_name = 'Please enter vendor name';
		} else {
			delete error.vendor_name;
		}
		if (
			!addVendorForm.vendor_display_name ||
			addVendorForm.vendor_display_name === '' ||
			addVendorForm.vendor_display_name === null
		) {
			error.vendor_display_name = 'Please enter vendor name';
		} else {
			delete error.vendor_display_name;
		}
		if (
			!addVendorForm.drug_license_number ||
			addVendorForm.drug_license_number === '' ||
			addVendorForm.drug_license_number === null ||
			(error.drug_license_number && addVendorForm.drug_license_number !== '')
		) {
			error.drug_license_number = error.drug_license_number ?? 'Please enter drug license number';
		} else {
			delete error.drug_license_number;
		}
		if (Object.keys(error).length > 0) {
			setVendorError(error);
			return true;
		} else {
			return false;
		}
	};

	const handleSave = async () => {
		let isError = checkValidation();
		if (isError) {
			toast.error('Unable to create vendor');
		} else {
			try {
				const data = await addNewVendor(addVendorForm);
				const updatedVendorList = [{ key: data.vendor_id, value: data.vendor_name }, ...vendorList];
				setVendorList(updatedVendorList);
				handleFormData('vendor_id', data?.vendor_id);
				onClose();
			} catch (error) {
				toast.error('Something went wrong!');
			}
		}
	};

	const validateLicense = (value) => {
		const regex = /^\d{2}-\d{5}-\d{5}-\d{5}$/;
		return regex.test(value);
	};
	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	function handleInputChange(key, value) {
		setAddVendorForm((prev) => ({
			...prev,
			[key]: value,
		}));
	}

	return (
		<div className="vendor-modal-overlay">
			<div className="vendor-modal">
				<div className="vendor-modal-header">
					<h2 style={{ fontWeight: '600' }}>Add New Vendor</h2>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={onClose}
					/>
				</div>

				<div className="vendor-modal-body">
					<div className="row g-3">
						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								style={{ width: '100%' }}
								label="Vendor Name"
								placeholder="Enter Vendor Name"
								type="text"
								required={true}
								value={addVendorForm.vendor_name}
								onBlur={(e) => {
									let error = { ...vendorError };
									let valueData = e.target.value;
									const value = valueData.replace(/[^A-Za-z\s']/g, '');
									if (value === '' || value === null) {
										error.vendor_name = 'Please enter vendor name';
										error.vendor_display_name = 'Please enter vendor display name';
										setVendorError(error);
										handleInputChange('vendor_name', value);
										handleInputChange('vendor_display_name', value);
									} else {
										delete error.vendor_name;
										delete error.vendor_display_name;
										setVendorError(error);
										handleInputChange('vendor_name', value);
										handleInputChange('vendor_display_name', value);
									}
								}}
								onChange={(valueData) => {
									const value = valueData.replace(/[^A-Za-z\s']/g, '');
									let error = { ...vendorError };
									if (value === '' || value === null) {
										error.vendor_name = 'Please enter vendor name';
										error.vendor_display_name = 'Please enter vendor display name';
										setVendorError(error);
										handleInputChange('vendor_name', value);
										handleInputChange('vendor_display_name', value);
									} else {
										delete error.vendor_name;
										delete error.vendor_display_name;
										setVendorError(error);
										handleInputChange('vendor_name', value);
										handleInputChange('vendor_display_name', value);
									}
								}}
								error={vendorError?.vendor_name}
								autoFocus={true}
							/>
						</div>

						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								label="Vendor Display Name"
								placeholder="Vendor Display Name"
								type="text"
								value={addVendorForm.vendor_display_name}
								onBlur={(e) => {
									let error = { ...vendorError };
									let valueData = e.target.value;
									const value = valueData.replace(/[^A-Za-z\s']/g, '');
									if (value === '' || value === null) {
										error.vendor_display_name = 'Please enter vendor display name';
										setVendorError(error);
										handleInputChange('vendor_display_name', value);
									} else {
										delete error.vendor_display_name;
										setVendorError(error);
										handleInputChange('vendor_display_name', value);
									}
								}}
								onChange={(valueData) => {
									const value = valueData.replace(/[^A-Za-z\s']/g, '');
									let error = { ...vendorError };
									if (value === '' || value === null) {
										error.vendor_display_name = 'Please enter vendor display name';
										setVendorError(error);
										handleInputChange('vendor_display_name', value);
									} else {
										delete error.vendor_display_name;
										setVendorError(error);
										handleInputChange('vendor_display_name', value);
									}
								}}
								required={true}
								error={vendorError?.vendor_display_name}
								onFocus={(e) => {}}
							/>
						</div>

						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								label="Drug License Number"
								placeholder="Drug License Number"
								type="text"
								required={true}
								value={addVendorForm.drug_license_number}
								onBlur={(e) => {
									let error = { ...vendorError };
									let value = e.target.value;
									if (value !== '' && value !== null) {
										delete error.drug_license_number;
										setVendorError(error);
										handleInputChange('drug_license_number', value);
									} else {
										error.drug_license_number = 'Please enter valid drug license number';
										setVendorError(error);
										handleInputChange('drug_license_number', value);
									}
								}}
								onChange={(value) => {
									let error = { ...vendorError };
									if (value !== '' && value !== null) {
										delete error.drug_license_number;
										setVendorError(error);
										handleInputChange('drug_license_number', value);
									} else {
										error.drug_license_number = 'Please enter valid drug license number';
										setVendorError(error);
										handleInputChange('drug_license_number', value);
									}
								}}
								error={vendorError?.drug_license_number}
							/>
						</div>
					</div>

					<div className="row g-3">
						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								style={{ width: '100%' }}
								label="Email"
								placeholder="Email Address"
								type="text"
								value={addVendorForm.email}
								onBlur={(e) => {
									let error = { ...vendorError };
									let value = e.target.value;
									if (value) {
										if (validateEmail(value)) {
											delete error.email;
											setVendorError(error);
											handleInputChange('email', value);
										} else {
											error.email = 'Please enter valid email address';
											setVendorError(error);
											handleInputChange('email', value);
										}
									}
								}}
								onChange={(value) => handleInputChange('email', value)}
								error={vendorError?.email}
							/>
						</div>

						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								style={{ width: '100%' }}
								label="Phone (Landline)"
								placeholder="Landline No."
								type="text"
								onBlur={(e) => {
									let error = { ...vendorError };
									let valueData = e.target.value;
									let value = valueData?.replace(/[^0-9]/g, '');
									if (value) {
										if (value.length > 10 || value.length < 9) {
											error.phone_landline = 'Please enter valid phone  landline number';
											handleInputChange('phone_landline', value);
											setVendorError(error);
										} else {
											delete error.phone_landline;
											setVendorError(error);
											handleInputChange('phone_landline', value);
										}
									} else {
										delete error.phone_landline;
										setVendorError(error);
										handleInputChange('phone_landline', value);
									}
								}}
								value={addVendorForm.phone_landline}
								onChange={(valueData) => {
									let error = { ...vendorError };
									let value = valueData?.replace(/[^0-9]/g, '');
									if (value) {
										if (value.length < 12) {
											if (value.length > 11 || value.length < 9) {
												error.phone_landline = 'Please enter valid phone landline number';
												handleInputChange('phone_landline', value);
												setVendorError(error);
											} else {
												delete error.phone_landline;
												setVendorError(error);
												handleInputChange('phone_landline', value);
											}
										}
									} else {
										delete error.phone_landline;
										setVendorError(error);
										handleInputChange('phone_landline', value);
									}
								}}
								error={vendorError?.phone_landline}
							/>
						</div>

						<div className="col-12 col-md-4 col-lg-4">
							<InputField
								label="Phone (Mobile)"
								placeholder="Vendor Mobile (Work)"
								type="text"
								value={addVendorForm.phone_mobile}
								onBlur={(e) => {
									let error = { ...vendorError };
									let valueData = e.target.value;
									let value = valueData?.replace(/[^0-9]/g, '');
									if (value) {
										const regex = /^[1-9]\d{9}$/;
										if (regex.test(value)) {
											if (value.length > 10 || value.length < 10) {
												error.phone_mobile = 'Please enter valid mobile number';
												handleInputChange('phone_mobile', value);
												setVendorError(error);
											} else {
												delete error.phone_mobile;
												setVendorError(error);
												handleInputChange('phone_mobile', value);
											}
										} else {
											error.phone_mobile = `Please enter valid mobile number ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
											handleInputChange('phone_mobile', value);
											setVendorError(error);
										}
									} else {
										delete error.phone_mobile;
										setVendorError(error);
										handleInputChange('phone_mobile', value);
									}
								}}
								onChange={(valueData) => {
									let error = { ...vendorError };
									let value = valueData?.replace(/[^0-9]/g, '');
									if (value) {
										if (value.length < 11) {
											const regex = /^[1-9]\d{9}$/;
											if (regex.test(value)) {
												if (value.length > 10 || value.length < 10) {
													error.phone_mobile = 'Please enter valid mobile number';
													handleInputChange('phone_mobile', value);
													setVendorError(error);
												} else {
													delete error.phone_mobile;
													setVendorError(error);
													handleInputChange('phone_mobile', value);
												}
											} else {
												error.phone_mobile = `Please enter valid mobile number ${value[0] === '0' ? 'and cannot start with 0' : ''}`;
												handleInputChange('phone_mobile', value);
												setVendorError(error);
											}
										}
									} else {
										delete error.phone_mobile;
										setVendorError(error);
										handleInputChange('phone_mobile', value);
									}
								}}
								error={vendorError?.phone_mobile}
							/>
						</div>
					</div>

					<div className="vendor-modal-footer">
						<button
							onClick={handleSave}
							className="vendor-save-btn"
						>
							Save Vendor
						</button>
						<button
							onClick={onClose}
							className="vendor-cancel-btn"
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddVendorModal;
